import React from 'react';

import { EnrollGeneralQuestions, EnrollTransitionScreen } from '../../../components';

import { EnrollContentProps } from './EnrollContentProps.types';

const EnrollContent = ({ progressBar, progressBarDispatch, handleBackBtnPress }: EnrollContentProps): JSX.Element => {
  if (progressBar.currentStepIndex === 0) {
    return (
      <EnrollTransitionScreen
        progressBarDispatch={progressBarDispatch}
      />
    );
  }

  return (
    <EnrollGeneralQuestions
      handleBackBtnPress={handleBackBtnPress}
      progressBarData={progressBar}
      progressBarDispatch={progressBarDispatch}
    />
  );
};

export default EnrollContent;
